import { Avatar, ListItem, Stack, Typography } from '@mui/material';
import { IResult } from '../hooks/useSearchLogic';
import { useIsDesktop } from 'Hooks';
import { sendEvent } from 'Utils/sendEvent';
import { getSearchResultIcon } from '../utils/getSearchResultIcon';

interface IResultItem {
  item: IResult;
}

export const ResultItem = ({ item }: IResultItem) => {
  const isDesktop = useIsDesktop();

  const handleClick = () => {
    if (!item.onClick) return;
    sendEvent('Search Page', 'SearchSuggestionClick');
    item.onClick();
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  const icon =
    item.indexType !== undefined ? getSearchResultIcon(item.indexType) : null;

  return (
    <ListItem sx={{ p: 0, width: '100%' }}>
      <Stack
        tabIndex={0}
        role='link'
        flexDirection={'column'}
        width='100%'
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        sx={{
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-between',
          maxWidth: '560px',
          width: 'fit-content',
          cursor: 'pointer',
          '&:hover': {
            '& .suggestion-label': {
              textDecoration: 'underline',
            },
          },
          '&:focus-visible': {
            outline: '2px solid #1552E8',
            outlineOffset: 2,
            borderRadius: '4px',
          },
        }}
      >
        <Stack direction='row' alignItems='center' gap='8px'>
          {icon && (
            <Avatar
              src={icon}
              alt=''
              sx={{
                width: isDesktop ? '20px' : '16px',
                height: isDesktop ? '20px' : '16px',
              }}
            />
          )}
          <Typography
            className='suggestion-label'
            sx={{
              fontSize: isDesktop ? '20px' : '16px',
              fontWeight: '400 !important',
              lineHeight: isDesktop ? '28px' : '22px',
              maxWidth: isDesktop ? 'fit-content' : undefined,
            }}
            color={'#1552E8'}
          >
            {item.label}
          </Typography>
        </Stack>
        {item.description && (
          <Typography
            sx={{
              fontSize: '18px',
              fontWeight: '400 !important',
              lineHeight: '24px',
              pr: 0,
            }}
            color={'text.secondary'}
          >
            {item.description}
          </Typography>
        )}
      </Stack>
    </ListItem>
  );
};
